import { render } from "./GhibliScene.vue?vue&type=template&id=46e511eb"
import script from "./GhibliScene.vue?vue&type=script&lang=js"
export * from "./GhibliScene.vue?vue&type=script&lang=js"

import "./GhibliScene.vue?vue&type=style&index=0&id=46e511eb&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__